import React from 'react';
import DivContainerBody from '../../../../../components/DivContainerBody';
import StepperTabs from '../../../../../components/StepperTabs/StepperTabs';
import StepTab from '../../../../../components/StepperTabs/StepTab';
import { EditIcon } from '../../../../../components/buttons/IconButtons';
import ButtonAction from '../../../../../components/buttons/ButtonAction';
import HeadTittle from '../../../../../components/HeadTittle';
import routes from '../../../../../Routes/routes';
import AssignedEmployees from './AssignedEmployees';
import SetUpPrivileges from './SetUpPrivileges';
import { STEPS_ROLES_UPDATE } from '../Model/AllowedModules';
import CreateNewRoleApp from '../Functionality/CreateNewRoleApp';
import AssignedEmployeesUpdate from './AssignedEmployeesUpdate';

/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle: Frontend - IBL
 * @Email: sgarcia@ibl.mx
 */

const UpdateRole = () => {
    const {
        handleCreateRole,
        activeStep,
        setActiveStep,
        handleStepChange,
        selected,
        setSelected,
        web,
        mobile,
        handleChange,
        emptyFields,
        updateSteps,
        selectedPermissions,
        setSelectedPermissions,
        singleRoleObj,
        id,
        readOnly,
        roleListData,
        initialUsers,
        setInitialUsers,
        item,
        handleDeleteEmployee,
        handleDeleteUsers,
        modified,
        setModified,
        emptyPrivilege,
        setEmptyPrivilege
    } = CreateNewRoleApp();
    return (
        <>
            <HeadTittle link={routes.roles.list} name={'update'}>
                <ButtonAction
                    id='btn_up_update'
                    name={'update'}
                    className={'btn-icon-edit'}
                    Icon={EditIcon}
                    onClick={() => {
                        handleCreateRole();
                    }}
                />
            </HeadTittle>

            <StepperTabs
                id={id}
                steps={updateSteps}
                activeStep={activeStep}
                isStepOptional={() => {}}
                setActiveStep={setActiveStep}
                handleStepChange={handleStepChange}
                disabled={false}
            >
                <StepTab index={STEPS_ROLES_UPDATE.PRIVILEGES} activeStep={activeStep} normalHeight={true}>
                    {activeStep === STEPS_ROLES_UPDATE.PRIVILEGES && (
                        <SetUpPrivileges
                            web={web}
                            mobile={mobile}
                             handleChange={ handleChange}
                            emptyFields={emptyFields}
                            selectedPermissions={selectedPermissions}
                            setSelectedPermissions={setSelectedPermissions}
                            id={id}
                            item={item}
                            readOnly={readOnly}
                            emptyPrivilege={emptyPrivilege}
                        />
                    )}
                </StepTab>
                <StepTab index={STEPS_ROLES_UPDATE.EMPLOYEES} activeStep={activeStep} normalHeight={true}>
                    {activeStep === STEPS_ROLES_UPDATE.EMPLOYEES && (
                        <AssignedEmployeesUpdate
                            selected={selected}
                            setSelected={setSelected}
                            id={id}
                            initialUsers={initialUsers}
                            setInitialUsers={setInitialUsers}
                            handleDeleteUsers={handleDeleteUsers}
                            modified={modified}
                            setModified={setModified}
                        />
                    )}
                </StepTab>
            </StepperTabs>
        </>
    );
};

export default UpdateRole;
